import { useEffect } from "react";
import { CONTACT } from "../lib/data";
import Seo from "../components/Seo";

export default function AGB() {
  useEffect(() => { window.scrollTo({ top: 0 }); }, []);
  return (
    <main data-testid="agb-page" className="pt-32 md:pt-40 pb-24 bg-[#F8F5EF] min-h-screen">
      <Seo title="AGB" path="/agb" noindex />
      <div className="container-x max-w-4xl">
        <div className="flex items-center gap-3 mb-6">
          <span className="overline">Rechtliches</span>
        </div>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[#1A1A1A] tracking-tight">
          Allgemeine <br />
          <span className="italic gold-text">Geschäftsbedingungen</span>.
        </h1>

        <section className="mt-12 space-y-3 text-[15px] leading-relaxed text-[#333] font-light">
          <p>
            <span className="font-medium text-[#1A1A1A]">Leistungsbereich / Marke:</span> {CONTACT.brand}<br />
            handelnd unter der Geschäftsbezeichnung: Artur Bäcker Immobilien<br />
            Inh. {CONTACT.name}<br />
            {CONTACT.street}<br />
            {CONTACT.zip} {CONTACT.city}<br />
            {CONTACT.country}
          </p>
          <p className="text-[13px] text-[#5A5A5A] uppercase tracking-[0.18em]">Stand: März 2026</p>
        </section>

        <section className="mt-14 space-y-10 text-[15px] leading-[1.75] text-[#333] font-light">
          <div>
            <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A] mb-4">1. Geltungsbereich</h2>
            <p>
              Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen WERTBILD,
              Inhaber Artur Bäcker, und seinen Auftraggebern über fotografische, videografische und
              visuelle Dienstleistungen. Abweichende Bedingungen des Auftraggebers finden keine
              Anwendung, es sei denn, ihrer Geltung wurde ausdrücklich schriftlich zugestimmt.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A] mb-4">2. Vertragsgegenstand</h2>
            <p>Gegenstand des Vertrages ist die Erstellung und Lieferung visueller Medien, insbesondere:</p>
            <ul className="mt-3 space-y-1.5 list-disc list-outside pl-5">
              <li>Immobilien- und Architekturfotografie</li>
              <li>Drohnenaufnahmen</li>
              <li>Videoproduktionen</li>
              <li>360°-Rundgänge</li>
              <li>Bildbearbeitung und Nachbearbeitung</li>
              <li>sonstige visuelle und grafische Leistungen gemäß Angebot</li>
            </ul>
            <p className="mt-4">
              Der konkrete Leistungsumfang ergibt sich ausschließlich aus dem individuell erstellten
              Angebot bzw. der Auftragsbestätigung.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A] mb-4">3. Vertragsschluss</h2>
            <p>Ein Vertrag kommt zustande durch:</p>
            <ul className="mt-3 space-y-1.5 list-disc list-outside pl-5">
              <li>schriftliche Angebotsannahme (E-Mail ausreichend),</li>
              <li>Terminvereinbarung nach Angebotsübermittlung</li>
              <li>oder ausdrückliche Beauftragung.</li>
            </ul>
            <p className="mt-4">
              Mündliche Nebenabreden bedürfen zu ihrer Wirksamkeit der schriftlichen Bestätigung.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A] mb-4">4. Preise &amp; Zahlungsbedingungen</h2>
            <p>
              Alle Preise verstehen sich netto zuzüglich der jeweils geltenden gesetzlichen
              Umsatzsteuer. Rechnungen sind, sofern nicht anders vereinbart, innerhalb von 14 Tagen
              ohne Abzug zur Zahlung fällig. Bei Zahlungsverzug ist WERTBILD berechtigt:
            </p>
            <ul className="mt-3 space-y-1.5 list-disc list-outside pl-5">
              <li>Verzugszinsen gemäß gesetzlicher Regelung zu berechnen,</li>
              <li>weitere Leistungen bis zum Zahlungseingang zurückzuhalten.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A] mb-4">5. Mitwirkungspflichten des Auftraggebers</h2>
            <p>Der Auftraggeber verpflichtet sich insbesondere:</p>
            <ul className="mt-3 space-y-1.5 list-disc list-outside pl-5">
              <li>den Zugang zum Objekt zum vereinbarten Termin sicherzustellen,</li>
              <li>das Objekt fotografierfähig bereitzustellen,</li>
              <li>relevante Informationen (Adresse, Ansprechpartner, Besonderheiten) vollständig und korrekt zu übermitteln.</li>
            </ul>
            <p className="mt-4">
              Mehraufwand, der aufgrund unzureichender Vorbereitung entsteht, kann gesondert berechnet werden.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A] mb-4">6. Leistungserbringung &amp; Einsatz von Partnern</h2>
            <p>
              Die Leistungserbringung erfolgt zum vereinbarten Termin oder innerhalb des
              vereinbarten Zeitraums. WERTBILD ist berechtigt, zur Erfüllung des Auftrags
              qualifizierte Partner (z. B. Fotograf, Videograf, Grafiker) einzusetzen. Vereinbarte
              Lieferzeiten gelten nur, sofern sie ausdrücklich Bestandteil des Angebots sind.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A] mb-4">7. Stornierung &amp; Ausfallhonorar</h2>
            <p>Eine Stornierung des vereinbarten Termins ist schriftlich mitzuteilen. Es gelten folgende Regelungen:</p>
            <ul className="mt-3 space-y-1.5 list-disc list-outside pl-5">
              <li>bis 24 Stunden vor dem Termin: kostenfrei</li>
              <li>12 – 24 Stunden vor dem Termin: 50 % des vereinbarten Honorars</li>
              <li>weniger als 12 Stunden vor dem Termin oder bei Nichterscheinen: 100 % des vereinbarten Honorars</li>
            </ul>
            <p className="mt-4">
              Bereits entstandene Zusatzkosten (z. B. Fremdleistungen) sind in jedem Fall zu erstatten.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A] mb-4">8. Nutzungsrechte</h2>
            <p>
              Nach vollständiger Zahlung erhält der Auftraggeber ein zeitlich und örtlich
              uneingeschränktes Nutzungsrecht an den gelieferten Medien. Die Nutzung ist zulässig für:
            </p>
            <ul className="mt-3 space-y-1.5 list-disc list-outside pl-5">
              <li>die Vermarktung von Immobilien,</li>
              <li>die Präsentation von Objekten,</li>
              <li>die Referenzierung der eigenen Tätigkeit,</li>
              <li>die Online- und Social-Media-Nutzung im vorgenannten Kontext.</li>
            </ul>
            <p className="mt-4">
              Eine Weitergabe an Dritte ist zulässig, sofern sie im unmittelbaren Zusammenhang mit
              der Vermarktung, Präsentation oder Referenzierung der jeweiligen Objekte steht.
            </p>
            <p className="mt-4">Nicht zulässig ist insbesondere:</p>
            <ul className="mt-3 space-y-1.5 list-disc list-outside pl-5">
              <li>die werbliche Nutzung außerhalb des Objektkontextes,</li>
              <li>die Nutzung als Stockmaterial,</li>
              <li>der Weiterverkauf oder die Lizenzierung der Medien an Dritte zu eigenständigen Zwecken.</li>
            </ul>
            <p className="mt-4">
              Die Urheberrechte verbleiben bei WERTBILD bzw. den beauftragten Urhebern.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A] mb-4">9. Korrekturen &amp; Reklamationen</h2>
            <p>
              Reklamationen sind innerhalb von 5 Tagen nach Lieferung schriftlich (per E-Mail)
              mitzuteilen. Dies gilt insbesondere bei der Inanspruchnahme der
              „Zufriedenheitsgarantie". Korrekturen erfolgen im Rahmen des vereinbarten
              Leistungsumfangs. Darüber hinausgehende Änderungen oder Neuaufnahmen sind gesondert zu vergüten.
            </p>
            <p className="mt-4">
              Die Bildbearbeitung erfolgt im individuellen, künstlerischen Stil des Fotografen.
              Subjektive Empfindungen des Auftraggebers (z. B. hinsichtlich Helligkeit, Farben oder
              Bildwirkung) begründen keinen Mangel, sofern die Ausführung den vereinbarten
              Referenzen entspricht.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A] mb-4">10. Haftung</h2>
            <p>WERTBILD haftet ausschließlich für Vorsatz und grobe Fahrlässigkeit. Für Schäden, die entstehen durch:</p>
            <ul className="mt-3 space-y-1.5 list-disc list-outside pl-5">
              <li>höhere Gewalt,</li>
              <li>witterungsbedingte Einschränkungen,</li>
              <li>behördliche Auflagen (z. B. Drohnenflugverbote),</li>
              <li>unzureichende Objektvorbereitung,</li>
              <li>Angaben Dritter,</li>
            </ul>
            <p className="mt-4">wird keine Haftung übernommen.</p>
          </div>

          <div>
            <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A] mb-4">11. Datenschutz</h2>
            <p>
              Es gelten die Bestimmungen der jeweils aktuellen{" "}
              <a href="/datenschutz" className="text-[#FFA500] hover:underline">Datenschutzerklärung</a>{" "}
              von WERTBILD.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A] mb-4">12. Schlussbestimmungen</h2>
            <p>
              Es gilt das Recht der Bundesrepublik Deutschland. Ist der Auftraggeber Kaufmann,
              juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen,
              ist – soweit gesetzlich zulässig – Gerichtsstand Düren. Sollten einzelne Bestimmungen
              dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Regelungen unberührt.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}
